export default "__VITE_ASSET__x3xUwvG1__"